import { Result, Subtask } from 'constants/interfaces'
import { findLatestSubtaskResults } from './results'

interface ExecutionPollInput {
  subtask: Subtask
  results: Result[]
  contextId: string
  recurrenceTs?: string | null
  votes: number[]
  knownContextIds?: Set<string>
}

interface ExecutionPollOption {
  label: string
  count: number
  percentage: number
}

const validSelections = (votes: number[], optionCount: number) =>
  Array.from(new Set(votes.filter((index) => Number.isInteger(index) && index >= 0 && index < optionCount)))

/** The local draft replaces this context's saved answer, including when the draft is cleared. */
export const getExecutionPollOptions = ({
  subtask,
  results,
  contextId,
  recurrenceTs,
  votes,
  knownContextIds,
}: ExecutionPollInput): ExecutionPollOption[] => {
  const options = subtask.options || []
  const selections = findLatestSubtaskResults(results, subtask.st_id, recurrenceTs)
    .filter((result) => result.context_id !== contextId && (!knownContextIds || knownContextIds.has(result.context_id)))
    .map((result) => validSelections(result.poll_selections || [], options.length))

  selections.push(validSelections(votes, options.length))

  const activeSelections = selections.filter((selection) => selection.length > 0)
  const counts = options.map(() => 0)

  activeSelections.forEach((selection) => selection.forEach((index) => counts[index]++))

  return options.map((label, index) => ({
    label,
    count: counts[index],
    percentage: activeSelections.length ? Math.round((counts[index] / activeSelections.length) * 100) : 0,
  }))
}

export const nextPollVotes = (votes: number[], index: number, multiple: boolean): number[] => {
  if (!multiple) return [index]

  return votes.includes(index) ? votes.filter((vote) => vote !== index) : [...votes, index]
}
